module.exports = __webpack_public_path__ + "static/media/CEDAPP_ICONE.b4c1762e.png";